import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

export default function Modal({ open = true, onClose, title, children, size = "md", footer, testId }) {
    // Lock body scroll while open + restore on close
    useEffect(() => {
        if (!open) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => { document.body.style.overflow = prev; };
    }, [open]);

    if (!open) return null;
    const w = size === "xl" ? "max-w-4xl" : size === "lg" ? "max-w-2xl" : size === "sm" ? "max-w-sm" : "max-w-md";
    // Portal to body so the modal isn't trapped inside any transformed ancestor
    // (CSS `transform`/`filter` on a parent re-roots `position: fixed` and would
    // anchor the modal to the parent instead of the viewport — that's why a
    // screenshot opened via a row near the bottom appeared at the page top).
    return createPortal(
        <div
            data-testid={testId}
            className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-sm fade-in"
            onClick={onClose}
        >
            <div className={`card w-full ${w} max-h-[90vh] flex flex-col`} onClick={(e) => e.stopPropagation()}>
                <div className="flex items-start justify-between p-6 pb-4 border-b border-slate-100 flex-shrink-0">
                    <h3 className="section-title text-lg">{title}</h3>
                    <button data-testid="modal-close" onClick={onClose} className="text-slate-400 hover:text-slate-700"><X className="w-5 h-5" /></button>
                </div>
                <div className="p-6 overflow-y-auto flex-1">
                    {children}
                </div>
                {footer && <div className="p-6 pt-4 border-t border-slate-100 flex justify-end gap-2 flex-shrink-0">{footer}</div>}
            </div>
        </div>,
        document.body,
    );
}
